<template>
  <div class="designs" v-loading="isLoading">
    <vue-waterfall-easy
      ref="waterfall"
      :imgsArr="designList"
      :gap="24"
      :maxCols="8"
      :imgWidth="324"
      @scrollReachBottom="loadmore"
    >
      <div class="card-item" slot-scope="props">
        <Cover
          :bgConfig="props.value.bgParameter"
          :elementImg="props.value.elementImg"
          :size="setCoverSize(props.value.size)"
          :elConfig="props.value.elementInfo"
          :textConfig="props.value.textInfo"
          :fontStyles="props.value.fontStyles"
        />
        <div class="mask">
          <span class="btn" @click="toDesignDetail(props.value.schemeId)"> <i class="el-icon-edit"></i>编辑 </span>
          <span class="btn" @click="delectConfirm(props.value.schemeId)"><i class="el-icon-delete"></i>删除</span>
        </div>
        <span class="save-time">保存于: {{ formatTime(props.value.time) }}</span>
        <div class="caption">
          <span class="count">共计 {{ props.value.count }} 张</span>
          <dropdown :designName="'cover'" :designData="props.value"></dropdown>
        </div>
      </div>
      <div slot="waterfall-over" class="no-more">
        {{ totalCount ? "没有更多内容了" : "" }}
      </div>
      <div slot="loading">
        <div v-if="isLoading" class="loading">loading...</div>
      </div>
    </vue-waterfall-easy>
    <div class="nothing" v-if="!totalCount">
      <span class="tips">您还没有添加内容，赶紧去添加吧</span>
      <button class="btn" @click="navigateBack">开始创意</button>
    </div>
    <el-dialog title="提示" :visible.sync="delectDialogVisible" top="25vh" width="400px" left>
      <span class="msg"><i class="iconfont icon-jingshi"></i>是否删除当前文件？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="immediateDelete(currentDesign)">删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/plugins/http";
import api from "@/assets/scripts/api";
import Cover from "@/pages/cover/components/cover.vue";
import vueWaterfallEasy from "vue-waterfall-easy";
import { mapMutations } from "vuex";
import dropdown from "@/components/dropdown.vue";
export default {
  name: "coverDesigns",
  data() {
    return {
      designList: [],
      // 要删除的设计id
      currentDesign: "",
      // 设计总数
      totalCount: 0,
      pageSize: 50,
      pageIndex: 1,
      // 瀑布流每行显示的个数
      waterfallColumnNum: 5,
      isLoading: false,
      hasMore: true,
      delectDialogVisible: false,
    };
  },
  components: {
    dropdown,
    Cover,
    vueWaterfallEasy,
  },
  async mounted() {
    this.waterfallColumnNum = Math.floor(window.innerWidth / (this.imgWidth + 24));
    await this.getDesginList();
  },
  methods: {
    ...mapMutations("cover", ["clearCoverCacheInfo"]),
    // 获取用户设计
    async getDesginList() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true;
      try {
        let {
          data: { list, totalCount },
        } = await http.get(api.schemes, {
          pageSize: this.pageSize,
          platformType: 2,
          pageIndex: this.pageIndex,
        });
        this.isLoading = false;
        if (!list || !list.length) {
          if (this.pageIndex === 1) {
            this.designList = [];
            this.totalCount = 0;
          }
          this.hasMore = false;
          this.$refs.waterfall.waterfallOver();
          return;
        }
        for (let coverMap of list) {
          const { fontStyles } = coverMap;
          fontStyles.forEach(textMap => {
            textMap.isShowText = !!textMap.text;
            textMap.isMainTitle = /Heavy|Black/.test(textMap.fontFamily) && !textMap.isLabelStyle;
          });
        }
        if (this.pageIndex === 1) {
          this.designList = list;
        } else {
          this.designList = this.designList.concat(list);
        }
        this.totalCount = totalCount;
      } catch (err) {
        this.isLoading = false;
        this.hasMore = false;
      }
    },
    async loadmore() {
      this.pageIndex += 1;
      this.getDesginList();
    },
    // 格式化日期
    formatTime(timeStamp) {
      const creatTime = Date.parse(new Date(timeStamp));
      const nowTime = Date.parse(new Date());
      const timePoor = nowTime - creatTime;
      if (timePoor <= 3600000) {
        return "刚刚";
      } else if (timePoor > 3600000 && timePoor < 86400000) {
        return `${Math.round(timePoor / 3600000)}小时前`;
      } else {
        return `${Math.round(timePoor / 86400000)}天前`;
      }
    },
    // 设置瀑布流里图片的大小
    setCoverSize({ width, height }) {
      if (width >= 300) {
        const colHeight = (300 * height) / width;
        return {
          width: 300,
          height: colHeight,
        };
      } else {
        return {
          width,
          height,
        };
      }
    },
    delectConfirm(id) {
      this.currentDesign = id;
      this.delectDialogVisible = true;
    },
    // 删除我的设计
    async immediateDelete(id) {
      let { code } = await http.delete(api.scheme + "/" + id);
      if (code === 10000) {
        this.pageIndex = 1;
        this.hasMore = true;
        this.getDesginList();
      }
      this.$message({
        type: "success",
        message: "删除成功!",
      });
    },
    // 去详情页面
    toDesignDetail(schemeId) {
      this.$router.push({
        path: "/cover/decorate",
        query: { schemeId },
      });
    },
    navigateBack() {
      this.clearCoverCacheInfo();
      this.$router.push({
        path: "/cover/size",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.designs {
  position: absolute;
  top: 126px;
  bottom: 0;
  width: 100%;
  padding: 30px 30px 100px;
  .loading,
  .no-more {
    text-align: center;
    padding: 20px 0;
  }
}
.card-item {
  position: relative;
  box-sizing: border-box;
  flex-basis: 600px;
  width: 324px;
  padding: 12px 12px 44px;
  margin: auto;
  background-color: #fff;
  border-radius: 12px;
  .cover {
    margin: auto;
  }
}
::v-deep .vue-waterfall-easy-container {
  .vue-waterfall-easy-scroll {
    .vue-waterfall-easy {
      .img-box {
        overflow: visible;
        &:hover {
          z-index: 20;
        }
      }
      a.img-inner-box {
        box-shadow: none;
        border-radius: 12px;
        overflow: visible;
      }
    }
  }
}
</style>
